var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIkonaZnakZapytania(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24a2b1",
    d: "M 53.738281 106.550781 C 48.355469 93.269531 47.171875 81.816406 56.792969 71.5625 C 64.011719 62.144531 82.863281 52.761719 84.496094 40.871094 C 87.882812 16.445312 56.292969 22.8125 58.820312 40.519531 C 60.113281 49.542969 56.382812 53.246094 49.664062 56.382812 C 40.546875 60.660156 34.199219 60.558594 33.328125 37.757812 C 32.742188 22.105469 44.597656 7.929688 59.828125 5.175781 C 78.195312 0.160156 106.605469 8.738281 112.921875 27.742188 C 117.585938 41.472656 111.199219 58.273438 98.304688 67.46875 C 78.171875 81.84375 69.292969 85.476562 69.257812 102.914062 C 69.230469 111.265625 56.996094 114.578125 53.738281 106.550781 Z M 53.738281 106.550781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#24a2b1",
    d: "M 80.636719 129.15625 C 81.792969 133.316406 81.566406 138.023438 79.1875 141.726562 C 74.042969 149.789062 64.675781 148.78125 57.285156 145.703125 C 51.007812 143.097656 48.492188 135.296875 51.257812 129.289062 C 54.566406 122.109375 60.152344 118.484375 66.449219 118.75 C 74.875 119.105469 78.585938 121.753906 80.636719 129.15625 Z M 80.636719 129.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonaZnakZapytania);
export default __webpack_public_path__ + "static/media/ikona-znak-zapytania.0ca9acb860fb5b63f6393cf573f419e6.svg";
export { ForwardRef as ReactComponent };